import { Component } from '@angular/core';
import { PageLayoutComponent } from '../../components/page-layout/page-layout.component';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-api-info',
  standalone: true,
  imports: [PageLayoutComponent],
  templateUrl: './api-info.component.html',
  styleUrl: './api-info.component.scss',
})
export class ApiInfoComponent {
  readonly apiBaseUrl = environment.API_BASE_URL;
  readonly demoScriptsUrl = 'https://github.com/Small-Bodies-Node/sbn-maqi-demo-scripts';

  readonly loginSnippet = `POST ${environment.API_BASE_URL}/api/auth/login
Content-Type: application/json

{
  "email": "you@example.edu",
  "password": "your-password"
}`;

  readonly submitSnippet = `POST ${environment.API_BASE_URL}/api/query
Authorization: Bearer <idToken>
Content-Type: application/json

{
  "query": "SELECT * FROM mpc_orbits LIMIT 10;"
}`;

  readonly statusSnippet = `GET ${environment.API_BASE_URL}/api/query/<job_id>
Authorization: Bearer <idToken>`;
}
